/**
 * 封装请求方法
 */

import vue from 'vue';
import router from '../src/router';
import {
  app
} from '../src/base/config.js'
import {
  store
} from '@/store'
const codeMessage = {
  200: '服务器成功返回请求的数据。',
  201: '新建或修改数据成功。',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: '删除数据成功。',
  400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
  401: '用户没有权限（令牌、用户名、密码错误）。',
  403: '用户得到授权，但是访问是被禁止的。',
  404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
  406: '请求的格式不可得。',
  410: '请求的资源被永久删除，且不会再得到的。',
  422: '当创建一个对象时，发生一个验证错误。',
  500: '服务器发生错误，请检查服务器。',
  502: '网关错误。',
  503: '服务不可用，服务器暂时过载或维护。',
  504: '网关超时。',
};

function checkStatus(response) {
  if(response.ok)
  {
    return response;
  }
  const errortext = codeMessage[response.status] || response.statusText;
  // notification.error({
  //     message: `请求错误 ${response.status}: ${response.url}`,
  //     description: errortext,
  // });
  const error = new Error(errortext);
  error.name = response.status;
  error.response = response;
  throw error;
}
function getToken(){
    if(window.apollo&&window.apollo.ApiToken){
      return window.apollo.ApiToken;
    }
    let tokenData = app.tokenUtil.getTokenData()
    let token = ''
    if (tokenData != undefined && tokenData != null) {
      token = tokenData;
    }
    token = token.replace(/"/g,'')
    init();

    function init(){
      window.apollo||(window.apollo={});
      window.apollo.ApiService = app.config.baseUrl;
      window.apollo.ApiToken = token;
    }
    return token;
}



/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */
export default function request(url, options) {
  const defaultOptions = {
    credentials: false, //'include', //'include',
    url: app.config.baseUrl + url,
    headers: {
      'Authorization':getToken()
    }
  };
  
  const newOptions = Object.assign(defaultOptions, options)
  if (
    newOptions.method === 'POST' ||
    newOptions.method === 'PUT' ||
    newOptions.method === 'DELETE'
  ) {
    if (!(newOptions.body instanceof FormData)) {
      newOptions.headers = Object.assign({
        'Accept': 'application/json',
        'Content-Type': 'application/json; charset=utf-8',
      }, newOptions.headers)
      newOptions.body = JSON.stringify(newOptions.body);
    } else {
      // newOptions.body is FormData
      newOptions.headers = Object.assign({
        'Accept': 'application/json'
      }, newOptions.headers)
    }
  }
  return vue.http(newOptions)
    .then(checkStatus)
    .then(response => {
      if (newOptions.method === 'DELETE' || response.status === 204) {
        return response.body;
      }
      return response.body;
    })
    .catch(e => {
      const status = e.name?e.name:e.status;
      if (status === 401) {

        if(window.apollo.ApiToken){
          window.apollo.ApiToken = null
        }

        let response={
          code:500,
          message:e.body.Message
        };
        return response;
      } else if (status <= 504 && status >= 500) {
        let response={
          code:500,
          message:e.body.Message
        };
        return response;
        
      } else if (status >= 402 && status < 422) {    
        store.dispatch('removeUserInfo');
        router.push('/login');
        window.location.reload();
      }
      Promise.reject(e);
    });
}



// WEBPACK FOOTER //
// ./utils/requests.js